import 'ui-core/plugins/slide/js/slide';
(function (UX) {
    var $body = $('body');
    let _ux3lvl_slide_init, _ux3lvl_slide_onShow, _ux3lvl_slide_onHide, _ux3lvl_slide_onOff;
    var slide = UX.slide;

    slide.vPort = 'screen-xs';

    // Save original functions

    _ux3lvl_slide_init = slide.init;
    _ux3lvl_slide_onShow = slide.on.show;
    _ux3lvl_slide_onHide = slide.on.hide;
    _ux3lvl_slide_onOff = slide.on.off;

    slide.init = function () {
        _ux3lvl_slide_init.apply(this, arguments);
        slide.$back.attr('tabindex', '-1');
    };

    slide.on.show = function () {
        _ux3lvl_slide_onShow.apply(this, arguments);
        slide.$back.removeAttr('tabindex');
    };

    slide.on.hide = function () {
        _ux3lvl_slide_onHide.apply(this, arguments);
        slide.$back.attr('tabindex', '-1');
    };

    slide.on.off = function () {
        _ux3lvl_slide_onOff.apply(this, arguments);
        slide.$back.attr('tabindex', '-1');
    };

    slide.responsive = function (index) {
        $(document).on(slide.vPort[index] + '-on', function () {
            // Waiting for custom event that will be triggered by controller.js to activate responsive effects
            slide.off = false;
            slide.$elements.css('transform', '');

            $('.w-slide__btn').each(function () {
                if ($(this).data('ctrl-res') === slide.vPort[index]) {
                    $(this).addClass('slide-active');
                }
            });
        });

        $(document).on(slide.vPort[index] + '-off', function (e) {
            // Waiting for custom event that will be triggered by controller.js to activate responsive effects
            slide.off = true;
            slide.on.off(e);
            slide.$elements.css('transform', '');

            $('.w-slide__btn').each(function () {
                if ($(this).data('ctrl-res') === slide.vPort[index]) {
                    $(this).removeClass('slide-active');
                }
            });
        });

        $(document).on(slide.elementvPort + '-on', function (e) {
            // Waiting for custom event that will be triggered by controller.js to activate responsive effects
            slide.isMobile = true;
            slide.$elements.css('margin-top', 0);

            slide.back = true;
            if ($body.attr('data-active') === 'slide') {
                slide.on.hide(e);
            }
        });

        $(document).on(slide.elementvPort + '-off', function (e) {
            // Waiting for custom event that will be triggered by controller.js to activate responsive effects
            slide.isMobile = false;

            slide.back = true;
            if ($body.attr('data-active') === 'slide') {
                slide.on.hide(e);
            }
        });
    };
})(UX);
